import { Alert, Box, CircularProgress } from '@mui/material';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';

function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 관리자 권한 체크 - role 기반으로 확인
  const isAdmin = user && user.role === 'admin';

  if (!isAdmin) {
    return (
      <Box p={3}>
        <Alert severity="error">
          관리자 권한이 필요합니다. 현재 사용자: {user.email || 'Unknown'}
          <br />
          관리자 계정으로 로그인해주세요.
        </Alert>
      </Box>
    );
  }

  return children;
}

export default AdminRoute;